import classNames from "classnames"
import React from "react"

import { PNImage } from "@bounce/web-components"

import type { GenericInterpolations } from "../../../../hooks/useGenericInterpolations"
import { useBenefits } from "../hooks/useBenefits"

type BenefitsProps = {
  interpolations: GenericInterpolations
  className?: string
}

export const Benefits = ({ interpolations, className }: BenefitsProps) => {
  const benefits = useBenefits({ interpolations })

  return (
    <section className={classNames("relative flex w-full max-w-screen-xl flex-col md:flex-row", className)}>
      <ul className="grid w-full gap-y-20 px-6 sm:grid-cols-2 sm:gap-x-16 lg:gap-y-36">
        {benefits.map((benefit, i) => (
          <li key={i}>
            <PNImage
              src={benefit.src}
              loading="lazy"
              width={160}
              height={160}
              className="mb-6 object-contain object-center md:mb-8"
            />
            <h3 className="title4 mb-3 lg:w-[70%]">{benefit.title}</h3>
            <p className="paragraph1">{benefit.description}</p>
          </li>
        ))}
      </ul>
    </section>
  )
}
